import React, { useRef, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { handleChangeDataModalEditPersonalInfo } from '../../../../redux/actions/partials/modals/modalEditPersonalInfo';
import { handleChangeDataModalProductRating } from '../../../../redux/actions/partials/modals/modalProductRating';
import { handleChangeDataOrderDetails } from '../../../../redux/actions/pages/user/orderDetails';
import { IMAGE_ADDRESS, PRODUCT_RATING } from '../../../../apis';
import useOutsideClick from './hooks/useOutsideClick'; 
import apiRequest from '../../../../utils/apiRequest';


const ModalProductRating = (props) => {

	const dispatch = useDispatch();

	const { isMobile } = useSelector(state => state.general);
	const { isActive, uniqueCode, product, comment, disableBtn } = useSelector(state => state.modalProductRating);
	const { content } = useSelector(state => state.orderDetails);
	const { token } = useSelector(state => state.login);
	const { isBackdropLoading } = useSelector(state => state.allLoaders);


	useEffect(() => {
	    if(isActive) {
	    	dispatch(handleChangeDataModalEditPersonalInfo('comment', product.comment));
	    	if(comment.length >= 3 && product.rate !== null)
	    		dispatch(handleChangeDataModalEditPersonalInfo('disableBtn', false));
	    	else
	    		dispatch(handleChangeDataModalEditPersonalInfo('disableBtn', true));
	    }
	}, [isActive]);



	const handleClose = () => {
		dispatch(handleChangeDataModalEditPersonalInfo('uniqueCode', ''));
		dispatch(handleChangeDataModalEditPersonalInfo('comment', ''));
		dispatch(handleChangeDataModalEditPersonalInfo('disableBtn', true));

		dispatch(handleChangeDataModalProductRating('isActive', false))
		setTimeout(() => {
            dispatch(handleChangeDataModalProductRating('isOpen', false));
        }, 250);
    };    


    const outerRef = useRef(null);
  	const centerBoxRef = useRef(null);
  	useOutsideClick(outerRef, centerBoxRef, handleClose, [ModalProductRating]);

  	

    const handleChangeInputs = (event) => {
    	const {name, value} = event.target;
    	dispatch(handleChangeDataModalProductRating(name, value));

    	if(value.length >= 3 && product.rate !== null)
    		dispatch(handleChangeDataModalProductRating('disableBtn', false));
    	else
    		dispatch(handleChangeDataModalProductRating('disableBtn', true));
    };

    const handleClickRate = (rate) => {
    	let newProduct = product;
    	newProduct.rate = rate;
    	dispatch(handleChangeDataModalProductRating('product', newProduct));
    };


    const handleSubmitForm = (event) => {
    	event.preventDefault();

    	if(! isBackdropLoading) {
    		apiRequest({
			    dispatch,
			    endpoint: PRODUCT_RATING,
			    method: 'post',
			    data: {uniqueCode, slug: product.slug, rate: product.rate, comment, type: 'comment'},
			    token: token, 
			    successMessage: 'امتیاز و دیدگاه شما با موفقیت ثبت شد',
			    onSuccess: (res) => {
			    	let newContent = content;
			    	content.consignments.map((consignment, key) => {
			    		if(consignment.uniqueCode === uniqueCode) {
			    			consignment.products.map((p) => {
			    				if(p.slug === product.slug) {
			    					p.rate = product.rate;
			    					p.comment = comment;
			    				}
			    			})
			    		}
			    	});

			    	dispatch(handleChangeDataOrderDetails('content', newContent));
			    	handleClose();
			    },
		  	});
    	}
    };



    const toPersianDigits = (num) => {
  		return num.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);
	};

	// const inputRefs = useRef({});
	// const handleOnInputFocus = (key) => {
 //        const currentInput = inputRefs.current[key];
 //        if (currentInput && errorTxt.length === 0) {
 //            dispatch(handleChangeInputLoginPage('inputClass', 'input-focused'));
 //            currentInput.classList.add("input-focused");
 //        }
 //    };

    return (

		<div ref={outerRef} className={`ReactModal__Overlay ${isActive ? 'ReactModal__Overlay--after-open' : ''}`} style={{position: 'fixed', inset: '0px', backgroundColor: 'rgba(0, 0, 0, 0.3)', zIndex: 9}}>
			<div ref={centerBoxRef} className="ReactModal__Content ReactModal__Content--after-open bg-neutral-000 absolute overflow-y-hidden rounded-medium styles_Modal__TsaRp" tabIndex="-1" role="dialog" aria-modal="true" style={ !isMobile ? {width: '460px'} : {width: '100%', maxHeight: '100vh', height: '100%'} }>
				<div className="flex flex-col h-full overflow-y-hidden styles_ModalLayout__y3Bs1" style={{paddingTop: '62px'}}>
					<div className="w-full z-1 bg-neutral-000 fixed top-0 right-0 px-5" width={460} height={61.59375}>
						<div className="flex items-center">
							<div className="grow text-h5">
								<div className="border-complete-b !border-b-4">
									<div className="flex items-center py-3 text-neutral-650">
										<div className="flex items-center">
											<div className="flex cursor-pointer">
												<div onClick={handleClose} className="cube-font-icon" data-icon-name="cube-nav-arrow-right" data-icon="" style={{width: '24px', height: '24px', fontSize: '24px', fontWeight: 'normal', color: 'var(--color-icon-high-emphasis)'}} ></div>
											</div>
											<span className="text-h5 mr-1">ثبت امتیاز و دیدگاه
											</span>
										</div>
										<span className="text-body-2 mr-auto">
										</span>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="grow flex flex-col overflow-y-auto">
						<div className="grow flex flex-col styles_children__hHq5Q p-0">
							<div>
								<div className="p-4" style={{paddingBottom: '112px'}}>
									<div className="flex flex-col items-start">
										<div className="flex items-start">
											<span className="flex flex-col items-start mb-4">
												<div className="shrink-0" style={{width: '56px', height: '56px', lineHeight: 0}}>
													<picture>
														<img className="w-full inline-block" src={IMAGE_ADDRESS + product.image} width={56} height={56} alt={product.title} title style={{objectFit: 'contain'}} />
													</picture>
												</div>
											</span>
											<div className="mr-3">
												<span>
													<p className="text-body1-strong text-neutral-800 ellipsis-1 grow-0">{product.title}
													</p>
												</span>
												<div className="flex items-center gap-1 text-caption whitespace-nowrap mt-2">
													<span target="_blank" className="flex items-center">
														<div className="flex text-neutral-700 ml-2">
															<svg style={{width: '18px', height: '18px', fill: 'var(--color-icon-high-emphasis)'}}>
																<use xlinkHref="#seller" />
															</svg>
														</div>
														<p className="text-neutral-500">{product.sellerTitle}
														</p>
														<div className="flex">
															<svg style={{width: '16px', height: '16px', fill: 'var(--color-icon-low-emphasis)'}}>
																<use xlinkHref="#dot" />
															</svg>
														</div>
													</span>
													<p className="text-neutral-500">{toPersianDigits(content.registerDate)}
													</p>
												</div>
											</div>
										</div>
									</div>
									<div className="flex items-center justify-between">
										<div className="text-subtitle-strong">
											<span> امتیاز ثبت شده:
											</span>
											<span className="text-primary-500">*
											</span>
										</div>
										<div className="mt-4 mb-5 gap-x-6 flex">
											<div className="flex flex-col items-center">
												<div onClick={() => handleClickRate(1)} className="flex cursor-pointer">
													<svg style={{width: '24px', height: '24px', fill: `${product.rate !== null && product.rate >= '1' ? 'var(--color-icon-warning)' : 'var(--color-icon-low-emphasis)'}`}}>
													<use xlinkHref={`#${product.rate !== null && product.rate >= '1' ? 'starFill' : 'starOutline'}`} />
													</svg>
												</div>
												<p className="text-body1-strong mt-2 text-neutral-700">۱
												</p>
											</div>
											<div className="flex flex-col items-center">
												<div onClick={() => handleClickRate(2)} className="flex cursor-pointer">
													<svg style={{width: '24px', height: '24px', fill: `${product.rate !== null && product.rate >= '2' ? 'var(--color-icon-warning)' : 'var(--color-icon-low-emphasis)'}`}}>
														<use xlinkHref={`#${product.rate !== null && product.rate >= '2' ? 'starFill' : 'starOutline'}`} />
													</svg>
												</div>
												<p className="text-body1-strong mt-2 text-neutral-700">۲
												</p>
											</div>
											<div className="flex flex-col items-center">
												<div onClick={() => handleClickRate(3)} className="flex cursor-pointer">
													<svg style={{width: '24px', height: '24px', fill: `${product.rate !== null && product.rate >= '3' ? 'var(--color-icon-warning)' : 'var(--color-icon-low-emphasis)'}`}}>
														<use xlinkHref={`#${product.rate !== null && product.rate >= '3' ? 'starFill' : 'starOutline'}`} />
													</svg>
												</div>
												<p className="text-body1-strong mt-2 text-neutral-700">۳
												</p>
											</div>
											<div className="flex flex-col items-center">
												<div onClick={() => handleClickRate(4)} className="flex cursor-pointer">
													<svg style={{width: '24px', height: '24px', fill: `${product.rate !== null && product.rate >= '4' ? 'var(--color-icon-warning)' : 'var(--color-icon-low-emphasis)'}`}}>
														<use xlinkHref={`#${product.rate !== null && product.rate >= '4' ? 'starFill' : 'starOutline'}`} />
													</svg>
												</div>
												<p className="text-body1-strong mt-2 text-neutral-700">۴
												</p>
											</div>
											<div className="flex flex-col items-center">
												<div onClick={() => handleClickRate(5)} className="flex cursor-pointer">
													<svg style={{width: '24px', height: '24px', fill: `${product.rate !== null && product.rate >= '5' ? 'var(--color-icon-warning)' : 'var(--color-icon-low-emphasis)'}`}}>
														<use xlinkHref={`#${product.rate !== null && product.rate >= '5' ? 'starFill' : 'starOutline'}`} />
													</svg>
												</div>
												<p className="text-body1-strong mt-2 text-neutral-700">۵
												</p>
											</div>
										</div>
									</div>
									<form>
										<div className="border-complete-b" />
										<div className="my-5">
											<div className="mb-2 flex items-center justify-between">
												<span className="text-subtitle-strong styles_required_badge__zrGFx">متن دیدگاه:
												</span>
											</div>
											<label className="FormComponentFrame_FormComponentFrame__PIUpy w-full FormComponentFrame_FormComponentFrame--normal__TQSOm">
												<div className="FormComponentFrame_FormComponentFrame__input-container__BHc4I FormComponentFrame_FormComponentFrame__input-container--textArea__qeOmL px-2 flex items-center relative text-neutral-800 Input_InputWrapper__d_4kf color-app-background !rounded-none !rounded-t-md !border-b-neutral-200 !border-l-neutral-300 !border-t-neutral-300 !border-r-neutral-300">
													<div className="grow text-body-3">
														<textarea className="px-1 TextField_TextField__textarea__fMFfN text-subtitle w-full TextField_TextField__bwN9_ TextField_TextField--secondary__w_vGF text-subtitle w-full py-5 lg:py-2 rounded-medium caret-black h-29" name="comment" placeholder="نظر خود را در مورد این کالا با کاربران دیگر به اشتراک بگذارید.." autoComplete="off" defaultValue={comment} onChange={handleChangeInputs} />
													</div>
												</div>
											</label>
										</div>
										<div className="mb-2">
											{/*<div className="flex overflow-x-scroll w-full gap-x-2 overflow-y-hidden styles_mediaContainer__zU75r">
												<div className="w-full">
													<div className="cursor-pointer">
														<div role="button" tabIndex={0} className="p-5 bg-neutral-000 rounded border-complete text-center border-complete-200 styles_UploadBox__dropZone__jrLQi !border-none bg-neutral-100 !p-4 h-18">
															<input accept="image/jpeg, image/png, video/mp4 ,video/x-m4v ,video/x-msvideo" type="file" autoComplete="off" tabIndex={-1} style={{display: 'none'}} />
															<div className="flex flex-col items-center justify-center">
																<div className="flex">
																	<div className="cube-font-icon" data-icon-name="cube-file-image-add" data-icon="" style={{width: '20px', height: '20px', fontSize: '20px', fontWeight: 'normal', color: 'var(--color-icon-black)'}} />
																</div>
																<p className="text-body2-strong mt-1">افزودن عکس یا ویدیو
																</p>
															</div>
															<div className="flex justify-evenly items-center mt-4" />
														</div>
													</div>
												</div>
											</div> */}
											<div className="mt-2 flex items-center">
												<div className="flex">
													<div className="cube-font-icon" data-icon-name="cube-alert-info-outline" data-icon="" style={{width: '16px', height: '16px', fontSize: '16px', fontWeight: 'normal', color: 'var(--color-icon-low-emphasis)'}} />
												</div>
												<span className="text-caption mr-1 text-neutral-400">بسیاری از کاربران در تصمیم‌گیری خود به تصاویر کالای شما نیاز دارند
												</span>
											</div>
										</div>
										<div className="w-full z-1 bg-neutral-000 px-5 py-4 bottom-0 shadow-1-top fixed right-0" width={420} height="79.859375">
											<button onClick={handleSubmitForm} disabled={disableBtn} className={`relative flex items-center user-select-none styles_btn__Q4MvL text-button-1 styles_btn--large__1Muai styles_btn--primary__y0GEv rounded-medium w-full mb-2 ${disableBtn ? 'styles_btn--disabled__lljQT pointer-events-none' : ''}`} type="submit">
												<div className="flex items-center justify-center relative grow">ثبت امتیاز و دیدگاه
												</div>
											</button>
											<p className="text-caption text-center">ثبت دیدگاه به معنی موافقت با
												<a className="mx-1 text-secondary-500" target="_blank" href="/page/comments-rules/">قوانین انتشار کوچی
												</a>است.
											</p>
										</div>
									</form>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>



        
    );
}

export default ModalProductRating;
